/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { getColor, pd } from '@airasia-phoenix/react-native/utils/utils';

export const styles = StyleSheet.create((pd) => ({
  container: {
    flex: 1,
    backgroundColor: getColor(pd.sys.colour.bg_primary),
  },
  feedContainer: {
    backgroundColor: getColor(pd.sys.colour.bg_primary),
  },
  tabBarContainer: {
    width: '100%',
    backgroundColor: getColor(pd.sys.colour.bg_primary),
    marginBottom: -pd.ref.space.spacing20.px,
  },
  endReachedSentinel: {
    height: 1,
    width: '100%',
  },
  movementsfeedContainer: {
    flex: 1,
    backgroundColor: pd.sys.colour.container_none.toString(),
    minHeight: 100,
  },
  feedLoaderContainer: {
    width: '100%',
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  initialStateContainer: {
    width: '100%',
    paddingVertical: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyStateContainer: {
    flex: 1,
    minHeight: 300,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
  },
  initialStateContent: {
    width: '100%',
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  initialStateMessage: {
    textAlign: 'center',
  },
  initialStateActionContainer: {
    marginTop: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  adCardContainer: {
    width: '100%',
    borderRadius: 16,
    overflow: 'hidden',
    backgroundColor: getColor(pd.sys.colour.container_low),
  },
}));

export default styles;
